/**
 * Pure helper: given safe-area insets and whether the modal is in a
 * fullscreen layout, return the top padding the content should carry.
 *
 * On iPhones with a notch / Dynamic Island, the fullscreen modal sits at
 * y=0 so without an inset the close-X button lands under the bezel and
 * can't be tapped (issue #128). Centered mode is unaffected because the
 * OS-drawn modal margins already avoid the safe area.
 *
 * Lives in utils/ (not inline in components/flex-modal.tsx) so it can be
 * unit-tested without pulling in the RN/expo-router transitive imports
 * the component itself has.
 */
export function computeFlexModalTopInset(
	insets: { top: number },
	opts: { isFullScreen: boolean; basePadding: number },
): number {
	return opts.isFullScreen ? insets.top + opts.basePadding : opts.basePadding;
}
